import * as PIXI from 'pixi.js';
import { waitForMs } from 'framework/utils/async-utils';

type Require = __WebpackModuleApi.RequireContext;
const atlasesContext: Require = require.context('../../../../static/atlases', true, /\.json$/);
const imagesContext: Require = require.context('../../../../static/images', true);
const fontsContext: Require = require.context('../../../../static/fonts', true);

export class Loader {
  private progress: number = 0;

  public async load(): Promise<void> {
    const loader: PIXI.loaders.Loader = PIXI.loader;

    atlasesContext.keys().forEach((key: string) => {
      loader.add(this.keyToName(key), `atlases/${key.slice(2)}`);
    });

    imagesContext.keys().forEach((key: string) => {
      loader.add(this.keyToName(key), `images/${key.slice(2)}`);
    });

    fontsContext.keys().forEach((key: string) => {
      const name: string = this.keyToName(key);
      const url: string = `fonts/${key.slice(2)}`;
      loader.add(name, url);
      loader.onComplete.add(() => this.addFontFace(name, url));
    });

    loader.onError.add(() => window.location.reload());
    const promise: Promise<void> = new Promise((fulfill: () => void): void => loader.onComplete.add(fulfill));
    loader.load();

    // TODO: check other way of for fonts
    await waitForMs(500);

    return promise;
  }

  private keyToName(key: string): string {
    return (key.split('/').pop() as string).split('.').shift() as string;
  }

  private addFontFace(name: string, url: string): void {
    const element: HTMLElement = document.getElementById('fonts') || this.createFontsElement();
    element.innerHTML += `@font-face {
  font-family: '${name}';
  src: url('${url}');
};`;

    const div: HTMLElement = document.createElement('div');
    div.innerText = '1';
    div.style.fontFamily = name;
    div.style.position = 'absolute';
    div.style.top = '-999px';
    document.body.appendChild(div);
  }

  private createFontsElement(): HTMLElement {
    const style: HTMLElement = document.createElement('style');
    style.id = 'fonts';
    document.body.appendChild(style);
    return style;
  }
}
